import * as defaultOperations from "./operations";
import { createQueryTester, EqualsOperation, createEqualsOperation } from "./core";
var createDefaultQueryTester = function (query, _a) {
    var _b = _a === void 0 ? {} : _a, compare = _b.compare, operations = _b.operations;
    return createQueryTester(query, {
        compare: compare,
        operations: Object.assign({}, defaultOperations, operations)
    });
};
export { EqualsOperation, createQueryTester, createEqualsOperation };
export * from "./operations";
export default createDefaultQueryTester;
